// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnAssignConfirmation-module__container {
  width: 552px;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.UnAssignConfirmation-module__container p {
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  line-height: 174%;
  letter-spacing: 0%;
  text-align: center;
}
.UnAssignConfirmation-module__closeHeader {
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
}
.UnAssignConfirmation-module__closeHeader button {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}
.UnAssignConfirmation-module__headingtext {
  font-family: Montserrat;
  font-weight: 600;
  font-size: 18px;
  line-height: 167%;
  letter-spacing: 0%;
  vertical-align: middle;
}

.UnAssignConfirmation-module__confirmationIcon {
  margin-top: 20px;
  margin-bottom: 20px;
}

.UnAssignConfirmation-module__btnContainer {
  display: flex;
  width: 100%;
  gap: 10px;
  margin-top: 20px;
}
.UnAssignConfirmation-module__cancelBtn {
  width: 100%;
  height: 45px;
  angle: 0 deg;
  opacity: 1;
  border-radius: 70px;
  padding-top: 14px;
  padding-right: 20px;
  padding-bottom: 14px;
  padding-left: 20px;
  gap: 8px;
  font-family: Montserrat;
  font-weight: 600;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 4%;
  text-align: center;
  text-transform: uppercase;
  font-variant-numeric-figure: lining-nums;
  font-variant-numeric-spacing: proportional-nums;
  text-align: center;
  text-transform: uppercase;
  background-color: #ffffff;
  border: 1px solid #263643;
  color: #263643;
  cursor: pointer;
}
.UnAssignConfirmation-module__unassignBtn {
  width: 100%;
  height: 45px;
  angle: 0 deg;
  opacity: 1;
  border-radius: 56px;
  padding-top: 14px;
  padding-right: 20px;
  padding-bottom: 14px;
  padding-left: 20px;
  gap: 10px;
  background-color: #ff3b30;
  font-family: Montserrat;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 4%;
  text-align: center;
  text-transform: uppercase;

  text-align: center;
  text-transform: uppercase;

  color: #ffffff;
  border: none;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/modals/unassignconfirmation/UnAssignConfirmation.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;EACxC,+CAA+C;EAC/C,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;;EAEzB,kBAAkB;EAClB,yBAAyB;;EAEzB,cAAc;EACd,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".container {\n  width: 552px;\n  background: #fff;\n  border-radius: 10px;\n  padding: 20px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.container p {\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 14px;\n  line-height: 174%;\n  letter-spacing: 0%;\n  text-align: center;\n}\n.closeHeader {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  cursor: pointer;\n}\n.closeHeader button {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n}\n.headingtext {\n  font-family: Montserrat;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 167%;\n  letter-spacing: 0%;\n  vertical-align: middle;\n}\n\n.confirmationIcon {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.btnContainer {\n  display: flex;\n  width: 100%;\n  gap: 10px;\n  margin-top: 20px;\n}\n.cancelBtn {\n  width: 100%;\n  height: 45px;\n  angle: 0 deg;\n  opacity: 1;\n  border-radius: 70px;\n  padding-top: 14px;\n  padding-right: 20px;\n  padding-bottom: 14px;\n  padding-left: 20px;\n  gap: 8px;\n  font-family: Montserrat;\n  font-weight: 600;\n  font-size: 14px;\n  leading-trim: NONE;\n  line-height: 100%;\n  letter-spacing: 4%;\n  text-align: center;\n  text-transform: uppercase;\n  font-variant-numeric-figure: lining-nums;\n  font-variant-numeric-spacing: proportional-nums;\n  text-align: center;\n  text-transform: uppercase;\n  background-color: #ffffff;\n  border: 1px solid #263643;\n  color: #263643;\n  cursor: pointer;\n}\n.unassignBtn {\n  width: 100%;\n  height: 45px;\n  angle: 0 deg;\n  opacity: 1;\n  border-radius: 56px;\n  padding-top: 14px;\n  padding-right: 20px;\n  padding-bottom: 14px;\n  padding-left: 20px;\n  gap: 10px;\n  background-color: #ff3b30;\n  font-family: Montserrat;\n  font-weight: 600;\n  font-style: SemiBold;\n  font-size: 14px;\n  leading-trim: NONE;\n  line-height: 100%;\n  letter-spacing: 4%;\n  text-align: center;\n  text-transform: uppercase;\n\n  text-align: center;\n  text-transform: uppercase;\n\n  color: #ffffff;\n  border: none;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UnAssignConfirmation-module__container`,
	"closeHeader": `UnAssignConfirmation-module__closeHeader`,
	"headingtext": `UnAssignConfirmation-module__headingtext`,
	"confirmationIcon": `UnAssignConfirmation-module__confirmationIcon`,
	"btnContainer": `UnAssignConfirmation-module__btnContainer`,
	"cancelBtn": `UnAssignConfirmation-module__cancelBtn`,
	"unassignBtn": `UnAssignConfirmation-module__unassignBtn`
};
export default ___CSS_LOADER_EXPORT___;
